














































































import { Component, Vue } from "vue-property-decorator";

import WalletExtension from "@/api/wallets/wallet-extension";
import WalletConnect from "@/api/wallets/walletconnect";
import EthService from "@/api/web3/eth";

import EventBus, { ACTIONS } from "@/event-bus";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

library.add(faSpinner);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class WalletConnector extends Vue {
  private onWaitingEvent = false;

  private walletItems: any[] = [
    {
      name: "Browser Extension",
      desc: "Activate through Metamask/Coin98",
      icons: ["/img/logos/metamask.svg", "/img/logos/coin98.svg"],
      connector: "browser_extension",
      disabled: false,
      wallet: WalletExtension,
    },
    {
      name: "WalletConnect",
      desc: "Activate through WalletConnect",
      icons: ["/img/logos/walletconnect.svg"],
      connector: "walletconnect",
      disabled: false,
      wallet: WalletConnect,
    },
    /* {
      name: "Coinbase Wallet",
      desc: "Connect to Coinbase Wallet on your phone",
      icons: ["/img/logos/coinbase_wallet.svg"],
      connector: "walletlink",
      disabled: true,
    },
    {
      name: "Ledger",
      desc: "Connect external Ledger wallet",
      icons: ["/img/logos/ledger_wallet.svg"],
      connector: "ledger",
      disabled: true,
    }, */
  ];

  private selectedWallet: any;

  private supportedWallets = ["browser_extension", "walletconnect"];

  get isWaitingConnect() {
    return this.onWaitingEvent;
  }

  private connectWallet(walletItem: any) {
    // Check that the selected connector is currently supported
    if (!this.supportedWallets.includes(walletItem.connector)) {
      console.log("connector not yet supported");
      return;
    }

    this.selectedWallet = walletItem;
    EventBus.$emit(ACTIONS.SELECTED_WALLET, this.selectedWallet.icons);

    EventBus.$emit(ACTIONS.WALLET_CONNECTING_EVT);
    this.onWaitingEvent = true;

    const wallet = new this.selectedWallet.wallet();
    EthService.setWallet(wallet);
    EthService.connect();
  }

  private cancelConnect() {
    this.onWaitingEvent = false;
    EventBus.$emit(ACTIONS.WALLET_CANCELED_EVT);
  }
}
